import React, { useEffect } from "react";
import { sendMessage } from "../../../../../helpers/fetch/messageUtils";

//Importar íconos de Material UI.
import {  Send } from '@mui/icons-material/';

// BtnSendMessage: Componente que renderiza el Botón para enviar un mensaje.

const BtnSendMessage = ({ type, mensaje, setMensaje, sessionSelected, filesSelected, messagesArray, handleClosePreview, keyDownSendMessage, setKeyDownSendMessage }) => {

    const handleSendMessage = async (typeFile) => { //Funcion para enviar un mensaje.
        if (typeFile === "text") { //Si el mensaje a enviarse es del tipo texto
            if (mensaje){
                sendMessage({
                    idMessegeSession: sessionSelected.IdSession,
                    identificador: sessionSelected.Identificador,
                    mensaje: mensaje,
                    type: type,
                });
                setMensaje("");
            }
        }
        else { // Si no, es de tipo file.
            // Mapear cada archivo en filesSelected y enviarlo individualmente
            console.log("este es el array completo con las posiciones: ",filesSelected )
            await Promise.all(filesSelected.map(async file => {
                let messageByFile = [];
                let message = "";
                if (messagesArray) messageByFile = messagesArray.filter( (message) => message.name === file.name);
                if (messageByFile.length > 0) message = messageByFile[0].message;
                try{
                    console.log("acá estoy a punto de enviar los archivos", file)
                    console.log("con estos mensajes correspondientes", )
                    const response = await sendMessage({
                        idMessegeSession: sessionSelected.IdSession,
                        identificador: sessionSelected.Identificador,
                        mensaje: message,
                        buffer: file,
                        type: typeFile,
                    });
                    console.log(`acabo de enviar este archivo "${file.name}" y esta es la respuesta: `, response)
                    setMensaje("");
                    handleClosePreview(); // ejecutar la funcion para cerrar la ventana de envio de archivos multimedia.
                } catch (error){
                    console.log("error al enviar el archivo individualmente", error);
                }
                
            }));
         }
    };

    useEffect(() => {
        const onKeyDownSendMessage = async () => {
            if(keyDownSendMessage === "enviar") { //Si el estado está en "enviar", quiere decir que se va a enviar un mensaje.
                if(mensaje) { //Si existe un mensaje para enviar desde el campo para escribir dentro del chat.
                console.log("se va a enviar un mensaje desde el botón", mensaje);
                handleSendMessage("text");
            }
            else if (!mensaje && !filesSelected){ //Si no existe ningún mensaje para enviar y no existen archivos multimedia seleccionados.
                console.log("no se va a enviar ningún mensaje desde el botón", mensaje);
            }
            else if (!mensaje && filesSelected && filesSelected.length > 0){ //Si no existe ningún mensaje, y existen archivos seleccionados.
                console.log("se va a enviar un archivo desde el botón", filesSelected);
                handleSendMessage("image"); //Se envían los archivos del tipo arhcivo.
            }
        }
            setKeyDownSendMessage(""); //Setear a vacío para el próximo envío de mensaje.
        };

        onKeyDownSendMessage();
    }, [keyDownSendMessage])

    return (
        <button onClick={() => handleSendMessage(type)} 
            className="chat-actions__button">
            <Send sx={{ fontSize: '25px' }} />
        </button>
    )
};

export default BtnSendMessage;